import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';

import { CNMCFile } from '../types';

import { cnmcQueryKeys } from './query-keys';

export type TCompleteMultipartUploadParams = {
  cnmcId: string;
  fileId: string;
};

export async function completeMultipartUpload({
  cnmcId,
  fileId,
}: TCompleteMultipartUploadParams): Promise<CNMCFile> {
  return mediaManagerClient.post(`/api/v1/cnmcs/${cnmcId}/files/${fileId}/complete`, {});
}

type MutationFn = typeof completeMultipartUpload;

type TUseCompleteMultipartUploadParams = {
  config?: MutationConfig<MutationFn>;
};

export function useCompleteMultipartUpload({
  config = {},
}: TUseCompleteMultipartUploadParams = {}) {
  return useMutation({
    ...config,
    mutationFn: completeMultipartUpload,
    onError(error) {
      console.error(error);
    },
    onSuccess(data, variables, context) {
      queryClient.invalidateQueries({ queryKey: cnmcQueryKeys.all });
      config.onSuccess?.(data, variables, context);
    },
  });
}
